import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  addLeaveManagement,
  addLeaveManagementSuccess,
  addLeaveManagementFailed,
  getLeaveManagement,
  getLeaveManagementFailed,
  getLeaveManagementSuccess,
  updateLeaveManagementStatus,
  updateLeaveManagementStatusSuccess,
  updateLeaveManagementStatusFailed,
  deleteLeaveManagement,
  deleteLeaveManagementFailed,
  deleteLeaveManagementSuccess,
  updateLeaveManagement,
  updateLeaveManagementSuccess,
  updateLeaveManagementFailed,
} from './slice';
import * as endpoints from './endpoints';
import { request } from '@app/services';

function* addLeaveManagementSaga(action: ReturnType<typeof addLeaveManagement>): any {
  try {
    const { leaveType, allowedDays } = action.payload;
    const result = yield call(request.post, endpoints.addLeaveManagement, {
      leaveType,
      allowedDays: Number(allowedDays),
    });
    yield put(addLeaveManagementSuccess(result.data));
  } catch (err) {
    yield put(addLeaveManagementFailed(err));
  }
}
// ----------------------------------------
function* getLeaveManagementSaga(action: ReturnType<typeof getLeaveManagement>): any {
  try {
    const result = yield call(request.get, endpoints.leaveManagement);
    yield put(getLeaveManagementSuccess(result.data));
  } catch (err) {
    yield put(getLeaveManagementFailed(err));
  }
}
// ----------------------------------------
function* updateLeaveManagementStatusSaga(
  action: ReturnType<typeof updateLeaveManagementStatus>
): any {
  try {
    const { row } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateLeaveManagementStatus}${row.id}`, {
      status: !row.status,
    });
    yield put(updateLeaveManagementStatusSuccess(result.data));
  } catch (err) {
    yield put(updateLeaveManagementStatusFailed(err));
  }
}
// ----------------------------------------
function* deleteLeaveManagementSaga(action: ReturnType<typeof deleteLeaveManagement>): any {
  try {
    const { id } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.delete, `${endpoints.deleteLeaveManagement}${id}`);
    yield put(deleteLeaveManagementSuccess(result.data));
  } catch (err) {
    yield put(deleteLeaveManagementFailed(err));
  }
}
// ----------------------------------------
function* updateLeaveManagementSaga(action: ReturnType<typeof updateLeaveManagement>): any {
  try {
    const { id, leaveType, allowedDays } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateLeaveManagement}${id}`, {
      leaveType,
      allowedDays: Number(allowedDays),
    });
    yield put(updateLeaveManagementSuccess(result.data));
  } catch (err) {
    yield put(updateLeaveManagementFailed(err));
  }
}
// ----------------------------------------
function* leaveManagementSagas() {
  yield all([
    takeLatest(addLeaveManagement, addLeaveManagementSaga),
    takeLatest(
      [
        getLeaveManagement,
        addLeaveManagementSuccess,
        updateLeaveManagementStatusSuccess,
        deleteLeaveManagementSuccess,
        updateLeaveManagementSuccess,
      ],
      getLeaveManagementSaga
    ),
    takeLatest(updateLeaveManagementStatus, updateLeaveManagementStatusSaga),
    takeLatest(deleteLeaveManagement, deleteLeaveManagementSaga),
    takeLatest(updateLeaveManagement, updateLeaveManagementSaga),
  ]);
}

export { leaveManagementSagas };
